import RiskAndQuality from './RiskAndQuality.vue'

export default [
  {
    path: 'risk-and-quality-review',
    name: 'Risk and Quality Review',
    component: RiskAndQuality
  }
]